import { Injectable, inject } from '@angular/core'
import { ExportAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { downloadFile } from '@services/download.helper'
import { map, switchMap } from 'rxjs/operators'
import { exportFeatures, exportSuccess } from './actions'

@Injectable()
export class MapExportEffects {
  readonly actions$ = inject(Actions)
  readonly exportAPIService = inject(ExportAPIService)

  FeaturesGeoJSONExportRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(exportFeatures),
      switchMap(({ mapId, ids, format }) => {
        switch (format) {
          case 'geojson':
            return this.exportAPIService.featuresGeoJSONExport(mapId, ids).pipe(
              map((res) => {
                downloadFile(res)
                return exportSuccess()
              }),
            )
          case 'csv':
            return this.exportAPIService.featuresCSVExport(mapId, ids).pipe(
              map((res) => {
                downloadFile(res)
                return exportSuccess()
              }),
            )
          case 'shapefile':
            return this.exportAPIService.featuresShapeFileExport(mapId, ids).pipe(
              map((res) => {
                downloadFile(res)
                return exportSuccess()
              }),
            )
        }
      }),
    ),
  )
}
